module.exports = __webpack_public_path__ + "static/media/ads_app.de08f5d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ads_app.jpg
// module id = 789
// module chunks = 0